import React, { Component } from "react";
import PropTypes from "prop-types";

// Utils
import Post from "../components/post/Post";
import PostSkeleton from "../util/PostSkeleton";

// Redux
import { connect } from "react-redux";
import { getPosts } from "../redux/actions/dataActions";
import { editUserDetails } from "../redux/actions/userActions";

// Material imports
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Slider from "@material-ui/core/Slider";

// widgets
//import Emoji from "../components/widgets/Emoji";

const styles = (theme) => ({
  ...theme.spreadThis,
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    marginTop: 0,
    marginBottom: 10,
    textAlign: "center",
    color: theme.palette.secondary,
    borderRadius: 15,
  },
  paperFilter: {
    padding: theme.spacing(2),
    marginTop: 0,
    marginBottom: 10,
    textAlign: "left",
    color: theme.palette.secondary,
    borderRadius: 15,
  },
  stickyTop: {
    // position: '-webkit-sticky',
    position: "fixed",
  },
});

class home extends Component {
  constructor() {
    super();
    this.state = {
      filteredPosts: "none",
      search: "",
      sizeFilters: [],
      date: null,
      open: true,
      heightFt: "",
      heightIn: "",
      weight: "",
      age: "",
      heightFilters: [48, 96],
      weightFilters: [100, 400],
      ageFilters: [10, 70],
    };
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSizeFilterChange = this.handleSizeFilterChange.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
  }

  applyFilters() {
    // var allPosts = this.props.data.posts;
    var allPosts = this.props.data.allPosts;

    console.log(allPosts);

    // Filter by height
    allPosts = allPosts.filter((post) => {
      const h = post.userHeight;
      return (
        (this.state.heightFilters[0] <= h &&
          h <= this.state.heightFilters[1]) ||
        h === undefined
      );
    });

    // Filter by weight
    allPosts = allPosts.filter((post) => {
      const h = post.userWeight;
      return (
        (this.state.weightFilters[0] <= h &&
          h <= this.state.weightFilters[1]) ||
        h === undefined
      );
    });

    // Filter by age
    allPosts = allPosts.filter((post) => {
      const h = post.userAge;
      return (
        (this.state.ageFilters[0] <= h && h <= this.state.ageFilters[1]) ||
        h === undefined
      );
    });

    if (this.state.search === "" && this.state.sizeFilters.length === 0) {
      // If no other filters are there, then load the posts
      this.setState({ filteredPosts: allPosts });
    } else {
      // Otherwise apply the filters
      var reducedList = [];

      // Filter by size choices
      if (this.state.sizeFilters.length !== 0) {
        allPosts.map((post) => {
          var postSize = post.size.toLowerCase();
          if (this.state.sizeFilters.indexOf(postSize) !== -1) {
            reducedList.push(post);
          }
        });
      } else {
        reducedList = allPosts;
      }

      if (this.state.search !== "") {
        reducedList = reducedList.filter((post) => {
          const lc = post.item.toLowerCase();
          const filter = this.state.search.toLowerCase();
          var bc = "brand"

          if(post.brand !== undefined)
            bc = post.brand.toLowerCase();

          return lc.includes(filter) || (bc.includes(filter) && bc !== "brand");
        });
      }
      this.setState({ filteredPosts: reducedList });
    }
  }

  handleSizeFilterChange(e) {
    var filterArray = this.state.sizeFilters;

    const index = filterArray.indexOf(e.target.name);
    if (index === -1) {
      filterArray.push(e.target.name);
    } else {
      filterArray.splice(index, 1);
    }
    //this.setState({ ...this.state, [e.target.name]: e.target.checked });
    this.setState({ sizeFilters: filterArray });
    this.applyFilters();
  }

  async handleSearchChange(e) {
    await this.setState({ search: e.target.value });
    this.applyFilters();
  }

  componentDidMount() {
    this.props.getPosts();
    this.setState({
      //filteredPosts: this.props.data.posts,
      filteredPosts: this.props.data.allPosts,
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      // filteredPosts: nextProps.data.posts,
      filteredPosts: nextProps.data.allPosts,
      // addedDetails: nextProps.user.credentials.addedDetails,
      addedDetails: nextProps.user.userProfile.addedDetails,
    });
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleSubmit = () => {
    console.log("inside handle submit");

    var heightConverted =
      parseInt(this.state.heightFt) * 12 + parseInt(this.state.heightIn);

    // console.log(this.props.user.credentials.addedDetails);
    console.log(this.props.user.userProfile.addedDetails);

    const userDetails = {
      height: heightConverted,
      weight: parseInt(this.state.weight),
      age: parseInt(this.state.age),
      addedDetails: true,
    };
    this.props.editUserDetails(userDetails);
    // this.props.user.credentials.addedDetails = true;
    this.props.user.userProfile.addedDetails = true;
    this.handleClose();
  };

  handleHeightChange = (event, newValue) => {
    this.setState({ heightFilters: newValue });
    this.applyFilters();
  };

  handleWeightChange = (event, newValue) => {
    this.setState({ weightFilters: newValue });
    this.applyFilters();
  };

  handleAgeChange = (event, newValue) => {
    this.setState({ ageFilters: newValue });
    this.applyFilters();
  };

  render() {
    const { classes } = this.props;
    // var { posts, loading } = this.props.data;
    //var { allPosts } = this.props.data;
    var loading = this.props.UI.loadingPosts;
    // posts = this.state.filteredPosts;
    var posts = this.state.filteredPosts;
    let recentPostsMarkup =
      !loading && posts !== "none" ? (
        posts.map((post) => <Post key={post.postId} post={post} />)
      ) : (
        <PostSkeleton />
      );

    // if (!this.props.user.credentials.addedDetails) {
    if (!this.props.user.userProfile.addedDetails) {
      console.log("welcome first time user!");
    } else {
      console.log("welcome back user!");
    }

    var userFeed =
      // !this.props.user.credentials.addedDetails &&
      !this.props.user.userProfile.addedDetails &&
      this.props.user.authenticated ? (
        <Grid container spacing={3} className={classes.root}>
          <Grid item sm />
          <Grid item sm>
            <Dialog open={this.state.open} aria-labelledby="form-dialog-title">
              <DialogTitle>Fit Details</DialogTitle>
              <form onSubmit={this.handleSubmit}>
                <DialogContent>
                  <DialogContentText>
                    Welcome to Fitcheck! Let's get you <b>fitted</b>
                  </DialogContentText>
                  <Typography variant="body1">Height</Typography>

                  <Grid container spacing={2}>
                    <Grid item>
                      <TextField
                        variant="outlined"
                        margin="dense"
                        name="heightFt"
                        label="Ft"
                        type="text"
                        className={classes.textField}
                        value={this.state.heightFt}
                        onChange={this.handleChange}
                        required
                        autoFocus
                        fullWidth
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        variant="outlined"
                        margin="dense"
                        name="heightIn"
                        label="Inches"
                        type="text"
                        className={classes.textField}
                        value={this.state.heightIn}
                        onChange={this.handleChange}
                        required
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    name="weight"
                    label="Weight (lbs)"
                    type="text"
                    className={classes.textField}
                    value={this.state.weight}
                    onChange={this.handleChange}
                    required
                    fullWidth
                  />
                  <TextField
                    variant="outlined"
                    margin="dense"
                    name="age"
                    label="Age"
                    type="text"
                    className={classes.textField}
                    value={this.state.age}
                    onChange={this.handleChange}
                    required
                    fullWidth
                  />
                </DialogContent>
                <DialogActions>
                  <Button type="submit" variant="contained" color="primary">
                    Submit
                  </Button>
                </DialogActions>
              </form>
            </Dialog>
          </Grid>
          <Grid item sm />
        </Grid>
      ) : (
        <Grid container spacing={3} className={classes.root}>
          <Grid item sm={3}>
            <Paper className={classes.paperFilter}>
              <form noValidate onSubmit={this.handleSubmit}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  name="search"
                  type="search"
                  label="search"
                  className={classes.textField}
                  onChange={this.handleSearchChange}
                  fullWidth
                  autoComplete="search"
                  autoFocus
                />
              </form>
              <hr></hr>
              <h2>Filters</h2>
              <FormControl component="fieldset" className={classes.formControl}>
                <FormLabel component="legend">Item Size</FormLabel>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.sizeFilters.indexOf("xs") !== -1}
                        onChange={this.handleSizeFilterChange}
                        name="xs"
                      />
                    }
                    label="XS"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.sizeFilters.indexOf("s") !== -1}
                        onChange={this.handleSizeFilterChange}
                        name="s"
                      />
                    }
                    label="S"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.sizeFilters.indexOf("m") !== -1}
                        onChange={this.handleSizeFilterChange}
                        name="m"
                      />
                    }
                    label="M"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.sizeFilters.indexOf("l") !== -1}
                        onChange={this.handleSizeFilterChange}
                        name="l"
                      />
                    }
                    label="L"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.sizeFilters.indexOf("xl") !== -1}
                        onChange={this.handleSizeFilterChange}
                        name="xl"
                      />
                    }
                    label="XL"
                  />
                </FormGroup>
                <FormLabel component="legend">User Parameters</FormLabel>
                <FormGroup>
                  <Typography id="range-slider" gutterBottom>
                    Height Range
                  </Typography>
                  <Slider
                    value={this.state.heightFilters}
                    onChange={this.handleHeightChange}
                    valueLabelDisplay="auto"
                    min={48} // 4' should be enough I think
                    max={96} // If anyone is taller than 8'...
                  />
                  <FormLabel component="legend">
                    {Math.floor(this.state.heightFilters[0] / 12)}'
                    {this.state.heightFilters[0] % 12}" -{" "}
                    {Math.floor(this.state.heightFilters[1] / 12)}'
                    {this.state.heightFilters[1] % 12}"
                  </FormLabel>
                  <Typography id="range-slider" gutterBottom>
                    Weight Range
                  </Typography>
                  <Slider
                    value={this.state.weightFilters}
                    onChange={this.handleWeightChange}
                    valueLabelDisplay="auto"
                    min={100} // 100 should be enough I think
                    max={400} // Hit a gym if you bigger than this...
                  />
                  <FormLabel component="legend">
                    {this.state.weightFilters[0]} lbs -{" "}
                    {this.state.weightFilters[1]} lbs
                  </FormLabel>
                  <Typography id="range-slider" gutterBottom>
                    Age Range
                  </Typography>
                  <Slider
                    value={this.state.ageFilters}
                    onChange={this.handleAgeChange}
                    valueLabelDisplay="auto"
                    min={18} // 100 should be enough I think
                    max={70} // Hit a gym if you bigger than this...
                  />
                  <FormLabel component="legend">
                    {this.state.ageFilters[0]} years -{" "}
                    {this.state.ageFilters[1]} years
                  </FormLabel>
                </FormGroup>
              </FormControl>
            </Paper>
          </Grid>
          <Grid item sm={6}>
            {recentPostsMarkup}
          </Grid>
          <Grid item sm={3}>
            <Paper className={classes.paper}>
              <Typography variant="body1">
                <b>Featured Fits (Coming soon!)</b>
              </Typography>
            </Paper>
            <Paper className={classes.paper}>
              <Typography variant="body1">
                <b>Popular Brands (Coming soon!)</b>
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      );
    return userFeed;
  }
}

home.propTypes = {
  classes: PropTypes.object.isRequired,
  getPosts: PropTypes.func.isRequired,
  editUserDetails: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  UI: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  data: state.data,
  UI: state.UI,
});

export default connect(mapStateToProps, { getPosts, editUserDetails })(
  withStyles(styles)(home)
);
